import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import escConstants from '../../constants';
import { useRoot } from '../../context/RootProvider';
import { DASHBOARD_ROUTE, VERIFICATION_ROUTE } from '../../routes/routePaths';

export interface IProtectedComponentProps {
  children?: React.ReactNode;
  allowed?: string[];
  extraInfo?: any;
}

const ProtectedComponent = ({
  children,
  allowed = [],
}: IProtectedComponentProps): JSX.Element | null => {
  const token =
    localStorage.getItem(escConstants.LOCAL_STORAGE_KEY.accessKey) ||
    'access-token';

  const location = useLocation();
  const { pathname } = location;
  const { auth: user } = useRoot();
  const role = user?.role ?? '';
  const userId = user?._id;

  if (!token || !userId) {
    return <Navigate to="/" replace />;
  }

  if (!user?.hasEmailVerified) {
    if (pathname.includes(VERIFICATION_ROUTE)) {
      return <>{children ?? <Outlet />}</>;
    }
    return <Navigate to={VERIFICATION_ROUTE} replace />;
  }

  if (pathname.includes(VERIFICATION_ROUTE)) {
    return <Navigate to={DASHBOARD_ROUTE} replace />;
  }

  if (Array.isArray(allowed) && allowed.length > 0 && !allowed.includes(role)) {
    return <Navigate to="/login" replace />;
  }

  // ✅ Never return booleans
  return <>{children ?? <Outlet />}</>;
};

export default ProtectedComponent;
